import { labelColor, text } from "@/theme/colors";
import { rounded, spacing } from "@/theme/variables";
import { USER_STATUS, USER_STATUS_LABEL } from "@/types/enum";
import { Box, styled } from "@mui/material";
import { FC } from "react";

export const UserStatusBadge: FC<{ status: string }> = ({ status }) => {
  const isActive = status === USER_STATUS.ACTIVE;
  const label = isActive ? USER_STATUS_LABEL[USER_STATUS.ACTIVE] : USER_STATUS_LABEL[USER_STATUS.DISABLED];

  return <Pill isActive={isActive}>{label}</Pill>;
};

const Pill = styled(Box, { shouldForwardProp: (p: string) => p !== "isActive" })<{ isActive: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 76px;
  height: 26px;
  padding: ${spacing.xxs} ${spacing.xs};
  border-radius: ${rounded.md};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  background-color: ${({ isActive }) => (isActive ? labelColor.progress : labelColor.disable)};
  color: ${({ isActive }) => (isActive ? text.primary : text.tertiary)};
`;
